export default __webpack_public_path__ + "static/media/ticket-item-swiss.7c931d54.png";